import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gray-50 border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          <p className="text-gray-600 mt-2">Last updated: January 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8">
  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      1. Information Collected
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide collects information to provide the service and manage your
      subscription.
    </p>
    <ul className="list-disc list-inside text-gray-600 space-y-1">
      <li>Email address and account details</li>
      <li>Information provided during onboarding (such as preferences)</li>
      <li>Weight entries, if you choose to log them</li>
      <li>Usage data related to how you interact with the app</li>
    </ul>
    <p className="text-gray-600 mb-3">
      Payments are processed securely by Stripe. MealGuide does not store full
      payment details.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      2. How Information Is Used
    </h2>
    <p className="text-gray-600 mb-3">Information is used to:</p>
    <ul className="list-disc list-inside text-gray-600 space-y-1">
      <li>Provide and operate the MealGuide service</li>
      <li>Generate and adjust meal plans</li>
      <li>Support optional nutrition tracking and logging features</li>
      <li>Review progress and improve the product</li>
      <li>Manage subscriptions and billing</li>
      <li>Communicate important service-related information</li>
    </ul>
    <p className="text-gray-600 mb-3">
      MealGuide does not use your data for unrelated marketing purposes.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Data Sharing</h2>
    <p className="text-gray-600 mb-3">
      MealGuide does not sell personal data.
    </p>
    <p className="text-gray-600 mb-3">
      Information may be shared only with trusted service providers required to
      operate the service, such as:
    </p>
    <ul className="list-disc list-inside text-gray-600 space-y-1">
      <li>Payment processing (Stripe)</li>
      <li>Hosting and infrastructure providers</li>
    </ul>
    <p className="text-gray-600 mb-3">
      These providers only receive information necessary to perform their
      services.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      4. Data Storage and Security
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide takes reasonable technical and organisational measures to
      protect data. However, no system can be guaranteed to be completely
      secure.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Your Rights</h2>
    <p className="text-gray-600 mb-3">
      You may request access to, correction of, or deletion of your personal
      data by contacting:
    </p>
    <p className="text-gray-600 mb-3">
      <strong>support@getmealguide.com</strong>
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Contact</h2>
    <p className="text-gray-600 mb-3">
      For privacy-related questions, contact:
    </p>
    <p className="text-gray-600 mb-3">
      <strong>support@getmealguide.com</strong>
    </p>
  </section>
</div>

      </div>

      {/* Footer */}
      <footer className="bg-gray-50 border-t mt-12">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-gray-600">
          © 2026 MealGuide. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
